<template>
    <div class="min-h-screen flex items-center justify-center">
        <div class="card-secondary max-w-lg mx-2 p-6 space-y-4">
            <p>
                Un lien d'activation vous a été envoyé par mail. Veuillez cliquer sur ce lien pour activer votre compte.
            </p>
            <p>
                Si vous n'avez pas reçu de mail, n'oubliez pas de vérifier dans vos spams.
            </p>

            <!-- Bouton renvoi -->
            <!-- Bouton renvoi -->
            <button class="btn-primary w-full mt-4" :disabled="loading || resent" @click="resendActivation">
                <span v-if="loading" class="loader-sm mr-2"></span>
                <span>
                    {{ resent ? "Lien déjà renvoyé" : (loading ? "Renvoi en cours..." : "Renvoyer le lien d’activation")
                    }}
                </span>
            </button>

            <router-link :to="{ name: 'LoginRegister', query: { view: 'login' } }"
                class="text-gold block text-center mt-4">
                Retour à la connexion
            </router-link>
        </div>
    </div>
</template>

<script setup>
import { ref } from "vue"
import axios from "axios"
import { useRoute } from "vue-router"

const route = useRoute()
const loading = ref(false)

const resent = ref(false)

const resendActivation = async () => {
    loading.value = true
    try {
        const email = route.query.email // récupéré depuis l’URL
        if (!email) throw new Error("Email manquant")

        await axios.post("/api/auth/resend-activation", { email })

        alert("Un nouvel email d’activation a été envoyé.")
        resent.value = true
    } catch (error) {
        alert(error.response?.data?.message || "Erreur lors du renvoi du mail")
    } finally {
        loading.value = false
    }
}
</script>
